fragment FakturoidDataFull on FakturoidData {
  proformaNumber
  invoiceNumber
  correctiveTaxDocumentUrl
}
